import { ContractRepositoryUserRegisterInput, ContractRepositoryUserRegisterOutput } from './4.2.contract/contract.user.register/contract.repository.user.register';
import { ContractNetworkingUserRegisterOutput } from './4.2.contract/contract.user.register/contract.networking.user.register';
import { Injectable } from '@angular/core';
import { ModelUserData } from './4.3.model/model.user.data';
import { NetworkingUserRegister } from './4.5.networking/networking.user.register';

@Injectable({
    providedIn: 'root'
})
export class RepositoryUserRegister implements
    ContractRepositoryUserRegisterInput,
    ContractNetworkingUserRegisterOutput
{

    constructor(
        private networking: NetworkingUserRegister
    ){
        this.networking.networkingOutput = this;
    }

    repoUserRegisterOutput?: ContractRepositoryUserRegisterOutput;

    repoUserRegister(
        name: string, 
        cellphone: string,
        email: string,
        params: any,
        timeToCall: number,
        callMeNow: number
    ): void {
        let modelUserData: ModelUserData = {
            name: name,
            cellphone: cellphone.toString(),
            email: email,
            params: params,
            timeToCall: timeToCall,
            callMeNow: callMeNow
        };
        this.networking.registerUser(modelUserData);
    }

    userRegisterSuccessfulOutput(): void {
        this.repoUserRegisterOutput?.repoRegisterUserSuccessfulOutput();
    }

    userRegisterFailureOutput(): void {
        this.repoUserRegisterOutput?.repoRegisterUserFailureOutput();
    }
    
}